export const PLAYABLE_MEDIA_TYPES = ["channel", "main"];
export const PLAYABLE_URL_SCHEMES = [
    "http:",
    "https:",
    "rtsp:",
    "rtsps:",
    "rtmp:",
    "rtmps:",
    "rtp:",
    "udp:",
];
export function isUrlWithScheme(value, schemes) {
    if (typeof value !== "string")
        return false;
    const trimmed = value.trim();
    if (trimmed === "" || /\s/.test(trimmed))
        return false;
    let url;
    try {
        url = new URL(trimmed);
    }
    catch {
        return false;
    }
    if (!schemes.includes(url.protocol))
        return false;
    return url.hostname !== "";
}
export function isPlayableResourceUrl(value) {
    return isUrlWithScheme(value, PLAYABLE_URL_SCHEMES);
}
export const DRM_CONTENT_ID_SOURCES = [
    "verimatrix",
    "drm-vsk",
];
export const DRM_LICENSABLE_PROTOCOL = "dash";
function hasDrmContentId(ids) {
    return ids.some((id) => DRM_CONTENT_ID_SOURCES.includes(id.source) &&
        typeof id.alternativeId === "string" &&
        id.alternativeId.trim() !== "");
}
export function assetPlaybackBlockers(asset, playableTypes) {
    var _a, _b, _c;
    const blockers = [];
    const medias = (_a = asset.medias) !== null && _a !== void 0 ? _a : [];
    const playable = medias
        .map((media, mediaIndex) => ({ media, mediaIndex }))
        .filter(({ media }) => playableTypes.includes(media.type));
    if (playable.length === 0) {
        blockers.push({ code: "no_playable_media" });
    }
    let encryptedCount = 0;
    let encryptedDashCount = 0;
    for (const { media, mediaIndex } of playable) {
        const resources = (_b = media.mediaResources) !== null && _b !== void 0 ? _b : [];
        if (resources.length === 0) {
            blockers.push({
                code: "media_has_no_resources",
                mediaIndex,
                ...(media.mediaId !== undefined ? { mediaId: media.mediaId } : {}),
                mediaName: (_c = media.name) !== null && _c !== void 0 ? _c : "",
            });
            continue;
        }
        const hasUsableRendition = resources.some((candidate) => (candidate.protocol === "hls" || candidate.protocol === "dash") &&
            isPlayableResourceUrl(typeof candidate.url === "string" ? candidate.url.trim() : ""));
        for (const [resourceIndex, resource] of resources.entries()) {
            const url = typeof resource.url === "string" ? resource.url.trim() : "";
            if (!isPlayableResourceUrl(url)) {
                blockers.push({
                    code: "resource_url_invalid",
                    mediaIndex,
                    resourceIndex,
                    url,
                });
            }
            if (resource.protocol === "other" && !hasUsableRendition) {
                blockers.push({
                    code: "resource_protocol_unknown",
                    mediaIndex,
                    resourceIndex,
                });
            }
            if (resource.isEncrypted === true) {
                encryptedCount += 1;
                if (resource.protocol === DRM_LICENSABLE_PROTOCOL) {
                    encryptedDashCount += 1;
                }
            }
        }
    }
    if (encryptedCount > 0) {
        if (asset.alternativeIds === undefined) {
            blockers.push({ code: "drm_content_id_unverified" });
        }
        else if (!hasDrmContentId(asset.alternativeIds)) {
            blockers.push({ code: "encrypted_without_drm_content_id" });
        }
        if (encryptedDashCount === 0) {
            blockers.push({ code: "encrypted_without_dash_resource" });
        }
    }
    return blockers;
}
export function channelPlaybackBlockers(asset) {
    return assetPlaybackBlockers(asset, PLAYABLE_MEDIA_TYPES);
}
export function isChannelPlayable(asset) {
    return channelPlaybackBlockers(asset).length === 0;
}
